// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  firebase: {
    apiKey: "AIzaSyAos3lgub9sVA4ahpURd4U3WFTxdOvBGG0",
    authDomain: "m2mtransight.firebaseapp.com",
    databaseURL: "https://m2mtransight.firebaseio.com",
    projectId: "m2mtransight",
    storageBucket: "m2mtransight.appspot.com",
    messagingSenderId: "321235367538",
    appId: "1:321235367538:web:453ed06215df1aa9dcf4eb",
    measurementId: "G-MS0PWS994K"
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
